import { SET_CAROUSEL_NAV_POINTER_X } from 'actions';

export function setCarouselNavPointerX(navPointerX: number) {
  return { navPointerX, type: SET_CAROUSEL_NAV_POINTER_X };
}
